// extracted by mini-css-extract-plugin
export var compact = "_mt-2";
export var phoneFrame = "_mt-0";
export var phoneScreen = "_mt-1";